import React from "react";
import PropTypes from "prop-types";
import PageSkeleton from "components/Skeleton/PageSkeleton";
import "./Loading.css";

function LoadingModal({
  loading,
  label = "Loading content…",
  type = "register",
  variant = "default",
  inline = false,
}) {
  if (!loading) return null;

  if (inline) {
    return <PageSkeleton type={type} variant={variant} label={label} />;
  }

  return (
    <div
      className="screen-loading-modal"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={label}
    >
      <div className="screen-loading-shell">
        <PageSkeleton type={type} variant={variant} label={label} />
      </div>
    </div>
  );
}

LoadingModal.defaultProps = {
  label: "Loading content…",
  type: "register",
  variant: "default",
  inline: false,
};

LoadingModal.propTypes = {
  loading: PropTypes.bool.isRequired,
  label: PropTypes.string,
  type: PropTypes.oneOf(["register", "detail", "editor", "dashboard"]),
  variant: PropTypes.oneOf(["default", "document", "expense", "contact"]),
  inline: PropTypes.bool,
};

export default LoadingModal;
